<template>
  <div class="info-con" v-loading="loading">
    <h2 class="tl-title" v-if="name !== ''">{{ name }}</h2>
    <div class="tl-con" v-if="list.length">
      <waterfall
        :col="6"
        :data="list"
        width="200"
        :gutterWidth="5"
        lazyDistance="100"
      >
        <div
          class="pr pbImgBox"
          v-for="item in list"
          :key="item"
          @click="goDesignworkbench(item)"
        >
          <el-image
            :style="item.style"
            :src="item.url"
            :data-attr="item.url"
            :alt="item.name"
          />
        </div>
      </waterfall>

      <Pagination
        v-if="Pagination.total > Pagination.page_size"
        @handleCurrentChange="handleCurrentChange"
        :Pagination="Pagination"
      />
    </div>
    <no-content v-else class="tl-con tl-cen" />
  </div>
</template>

<script>
import { HomeSetting, Template } from "@/config/axios/new_api";
import noContent from "@/components/common/noContent.vue";
import Index from "@/config/mixin/index.js";
export default {
  components: { noContent },
  mixins: [Index],
  data() {
    return {
      list: [{}],
      name: "",
      loading: false,
      Pagination: {
        total: 0,
        page: 1,
        page_size: 25,
      },
    };
  },
  created() {
    this.Pagination.page = this.$route.query.page ? this.$route.query.page : 1;
    this.getData();
  },
  mounted() {},
  methods: {
    getData(status = false) {
      let { id, name, type, page } = this.$route.query;
      this.name = name;
      if (id) {
        this.loading = true;
        this.list = [];
        if (type === "template") {
          let data = {
            home_template_class_id: id,
          };
          HomeSetting.choose(data).then((res) => {
            if (status) {
              this.$waterfall.forceUpdate();
            }
            this.$nextTick(() => {
              this.loading = false;
              var issafariBrowser =
                /Safari/.test(navigator.userAgent) &&
                !/Chrome/.test(navigator.userAgent);
              this.list = res.data.map((item) => {
                item.url = issafariBrowser
                  ? item.cover_url
                  : item.thumbnail_url;
                let [width, height] = item.size.split("x");
                let newWidth = 0,
                  newHeight = 0;
                if (width / 6 !== 180) {
                  newHeight = (180 / width) * height;
                  newWidth = 180;
                } else {
                  newWidth = 180;
                  newHeight = (180 / width) * height;
                }

                item.style = {
                  width: newWidth + "px",
                  height: newHeight + "px",
                  background: "#000",
                };
                return item;
              });
            });
          });
        } else {
          Template.templates({
            dir_id: id,
            per_page: this.Pagination.page_size,
            page: page || this.Pagination.page,
          }).then((res) => {
            if (status) {
              this.$waterfall.forceUpdate();
            }
            this.list = [];
            this.$nextTick(() => {
              let template = res.data.current_team.templates;
              var issafariBrowser =
                /Safari/.test(navigator.userAgent) &&
                !/Chrome/.test(navigator.userAgent);
              this.list = template.data.map((item) => {
                item.url = issafariBrowser
                  ? item.cover_url.replace("format,webp", "format,png") :
                  item.cover_url;
                let [width, height] = item.size.split("x");
                let newWidth = 0,
                  newHeight = 0;
                if (width / 6 !== 180) {
                  newHeight = (180 / width) * height;
                  newWidth = 180;
                } else {
                  newWidth = 180;
                  newHeight = (180 / width) * height;
                }
                item.style = {
                  width: newWidth + "px",
                  height: newHeight + "px",
                };
                return item;
              });
              this.Pagination.total = template.total;
            });
            this.loading = false;
          });
        }
      } else {
        this.list = [];
      }
    },
    // 分页查询
    handleCurrentChange(val = 1) {
      this.Pagination.page = val;
      this.getData(true);
      // let { id, name, type } = this.$route.query;
      // this.name = name;
      // this.$router.push({
      //   path: `/template_list`,
      //   query: {
      //     id,
      //     name,
      //     type,
      //     page: val,
      //   },
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.tl-title {
  margin: 80px 0 0;
  color: #3c3c43;
  line-height: 33px;
  font-size: 24px;
  text-align: center;
}
.pbImgBox {
  cursor: pointer;
  padding: 10px;
  transition: all 0.3s;
  &:hover {
    background: #f3f3f3;
    border-radius: 8px;
    .text-title {
      display: block;
    }
    // > div {
    //   padding: 10px;
    // }
  }
  > div {
    width: 180px;
  }

  img {
    width: 100%;
    height: auto;
  }
  .text-title {
    height: 34px;
    padding: 2px 10px 0;
    color: #3b3946;
    display: none;
  }
}
.tl-con {
  width: 1260px;
  height: 500px;
  margin: 60px auto 0;
}
.tl-cen {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
::v-deep(.vue-waterfall.is-transition img) {
  opacity: 1;
}
</style>
